import React from 'react';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { INITIAL_FEEDBACK, type FeedbackType } from '../../utils/reducer';
import ServiceBlock from '../ServiceBlock';
import type { UseServiceFeedbackType } from '../../hooks/useServiceFeedback';
import type { ClientLfaConversion } from '~/components/page/LFA/types';

type Props = Pick<
  UseServiceFeedbackType,
  | 'errorsToShowLookup'
  | 'clearValidationErrorForField'
  | 'handleUpdateFeedback'
  | 'handleRemoveService'
> & {
  initialSelectedServices: ClientLfaConversion['selectedServices'];
  selectedServices: ClientLfaConversion['selectedServices'];
  serviceFeedback: Map<string, FeedbackType>;
};

const Services: React.FCC<Props> = ({
  initialSelectedServices,
  selectedServices,
  serviceFeedback,
  errorsToShowLookup,
  clearValidationErrorForField,
  handleUpdateFeedback,
  handleRemoveService,
}) => (
  <JustificationContainer direction="column" gap="s" width="100%">
    {selectedServices.map(service => {
      const feedback = serviceFeedback.get(service.id) ?? INITIAL_FEEDBACK;
      const serviceError = [
        ...(errorsToShowLookup['criteria'] || []),
        ...(errorsToShowLookup['customReason'] || []),
      ].find(error => error.serviceId === service.id);

      const isRemovable = !initialSelectedServices.find(
        s => s.id === service.id,
      );

      return (
        <ServiceBlock
          error={serviceError}
          clearValidationErrorForField={clearValidationErrorForField}
          key={service.id}
          service={service}
          updateLocalFeedback={handleUpdateFeedback}
          serviceFeedback={feedback}
          onRemoveService={
            isRemovable ? () => handleRemoveService(service) : undefined
          }
        />
      );
    })}
  </JustificationContainer>
);

export default Services;
